import styled from 'styled-components';
import { variables } from 'components/theme';
import { navbarColor, navbarTextColor } from 'utils/theme';
import { Link } from 'react-router-dom';

export const Wrapper = styled.nav`
  width: 100%;
  background-color: ${navbarColor};
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);
  // border-bottom: 3px solid ${variables.colors.yellow};
  padding: 11px 0;
  height: 56px;
  position: fixed;
  z-index: 20;

  .color {
    display: flex;
  }

  a {
    outline: none;
    -webkit-tap-highlight-color: transparent;
  }

  @media (max-width: 658px) {
    height: 56px;
    display: flex;
    align-items: center;
  }
`;

export const HomeLink = styled(Link)``;

export const DesktopSearch = styled.button`
  width: 40%;
  background: ${variables.colors.white};
  border-radius: 8px;
  border: none;
  justify-content: flex-start;
  padding: 10px;
  position: relative;
  bottom: 3px;
  ${variables.fonts.openSansSemiBold};

  svg {
    margin-right: 8px;
  }
`;

export const DesktopMenu = styled.div`
  position: relative;
  display: flex;
  width: 100%;

  @media (min-width: 768px) {
    justify-content: flex-end;
  }

  .dropdown-btn {
    border: none;
    background-color: transparent;
    color: ${navbarTextColor};
    font-weight: 700;
    padding: 0 28px;
  }
`;

export const MobileMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  @media (max-width: 768px) {
    .dropdown-btn {
      border: none;
      background-color: transparent;
      color: ${variables.colors.grey15};
      font-weight: 700;
      padding: 0 14px;
      text-align: right;
      width: 67px;
      height: 40px;
      margin-right: -21px;
    }
  }

  @media (min-width: 768px) {
    .dropdown-btn {
      display: none;
    }
  }
`;

export const DarkModeToggle = styled.div`
  display: flex;
  align-items: center;
`;

export const ToggleSpan = styled.span`
  ${variables.fonts.overpassMonoBold}
`;
